import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { BasicTextInputComponent } from '../../form/base-components/base-text-input/basic-text-input.component';
import { LoginType } from '../../../classes/LoginType';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { WindowService } from '../../../../../common/angular-shared/services/window/window.service';

@Component({
  moduleId: module.id,
  selector: 'login',
  templateUrl: './base-login.component.html',
})
export class BaseLoginComponent implements OnInit {
  errorMessage: string;
  buttonDisabled: boolean;
  isLoading: boolean;
  @Input() withNewEmail: boolean;
  @ViewChild('loginEmail') loginEmailInput: BasicTextInputComponent;
  @ViewChild('loginPassword') loginPasswordInput: BasicTextInputComponent;

  constructor(
    private amorphicService: AmorphicService,
    private authenticationService: AuthenticationService,
    private windowService: WindowService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.buttonDisabled = true;
    this.isLoading = false;
  }

  async login(): Promise<void> {
    if (!this.validate()) {
      return;
    }

    this.isLoading = true;
    const loginType = this.withNewEmail ? LoginType.withNewEmail : LoginType.normal;

    try {
      await this.authenticationService.login(loginType);
      this.router.navigate(['account-center']);
    } catch (error) {
      this.errorMessage = 'Incorrect password or email.';
      this.isLoading = false;
    }
  }

  goToRegister(): void {
    this.authenticationService.goToRegister();
  }

  goToReset(): void {
    this.router.navigate(['login'], { fragment: 'Reset' });
  }

  // returns if the fields are currently valid
  validate(): boolean {
    this.errorMessage = '';

    if (
      this.loginEmailInput.val &&
      !this.loginEmailInput.isError &&
      this.loginPasswordInput.val &&
      !this.loginPasswordInput.isError
    ) {
      this.buttonDisabled = false;
      return true;
    } else {
      this.buttonDisabled = true;
      return false;
    }
  }

  showRegisterLink(): boolean {
    const customer = this.amorphicService.controller.customer;
    return !customer.isMMDirectCustomer(); // No new MMD customers
  }
}
